module.exports = __webpack_public_path__ + "static/media/home-hardware.6262d575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/home-hardware.jpg
// module id = 1316
// module chunks = 0